<template>
    <div class='flex-column flex-expand'>
        <div class="flex-expand page-content">
            <div class='centered'>
                <div v-if="baseData?.viewingUser">
                    <template v-if="mode=='global'">                        
                    </template>
                    <template v-else>
                        <router-link :to='`/mapp/groups`'>Back</router-link>
                    </template>
                    
                </div>            
                <div>
                    <div class="title">{{$t("Login")}}</div>
                    <div class="mb-3">
                        <div class="inf-group">
                            <input name="email" type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Email" v-model="email">
                        </div>
                        <div class="inf-group">
                            <input name="password" type="password" class="form-control" id="password" :placeholder="$t('Password')" v-model="password">
                        </div>
                        <div class="inf-group flex-row">                            
                            <input name="keep-me-in" type="checkbox" class="form-check-input" id="keep-me-in" v-model="keepMeIn">
                            <label class="form-check-label" for="keep-me-in">{{$t("Remember me")}}</label>
                            <span class="forget-password flex-expand" style="text-align: right;">
                                <a href="/auth/reset/">{{$t("Forget?")}}</a>
                            </span>
                        </div>
                        
                        <div class="inf-group flex-row buttons">
                            <button class="btn btn-primary button-login" @click="login">{{$t("Login")}}</button>
                            <template v-if="mode=='global'">
                                <a class="btn btn-secondary" :href='`/mapp/register`'>{{$t("Register")}}</a>
                            </template>
                            <template v-else>
                                <router-link class="btn btn-secondary" :to='`/mapp/register`'>{{$t("Register")}}</router-link>
                            </template>
                        </div>

                        <div class="externalSystems">
                            <a title="Google" :href="`https://accounts.google.com/o/oauth2/auth?scope=https://www.googleapis.com/auth/userinfo.email&redirect_uri=${host}/auth/authenticate_google&response_type=code&client_id=65527047760-q4oqgi4kjn3ki4kvoheeu3m4jch0cmh8.apps.googleusercontent.com`" class="">
                                <img class="oauth-i" src="/static/images/oauth/google.svg"  />
                            </a>
                            <a title="VK" :href="`https://oauth.vk.ru/authorize?client_id=7458352&display=mobile&redirect_uri=${host}/auth/authenticate_vk&scope=offline,email&response_type=code&v=5.131`" class="">
                                <img class="oauth-i" src="/static/images/oauth/vk.svg"  />
                            </a>
                            <a title="Facebook" :href="`https://www.facebook.com/v17.0/dialog/oauth?client_id=1152558645098184&redirect_uri=${host}/auth/authenticate_fb&state=none`" class="">
                                <img class="oauth-i" src="/static/images/oauth/facebook.svg"  />
                            </a>
                            <a title="Slack" :href="`https://slack.com/oauth/authorize?client_id=1828059125957.1824376133526&scope=users.profile:read,chat:write:bot&redirect_uri=${host}/auth/slack&state`" class="">
                                <img class="oauth-i" src="/static/images/oauth/slack.svg"  />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import i18n from '@root/components/i18n';
import Helper from '@root/components/helper';
import Api from '@root/components/api';


export default {
    props: ["mode"],
    mixins: [i18n],
    inject: ["baseData"],
    components: {
    },
    data() {
        return {
            email: "",
            password: "",
            error: "",
            keepMeIn: true,
            host: document.location.origin,
        };
    },
    mounted() {
        document.title = this.$t('Login');
    },
    methods: { 
        async login() {
            const response = await Api.postData('/auth/loginAjax', {
                Email: this.email,
                Password: this.password,
                keepMeIn: this.keepMeIn,
            });
            if (response == 'OK') {
                Api.showSuccess("Success");
                let returnUrl = localStorage.getItem("return_url");
                location.href = returnUrl || '/mapp';
            } 
            else {
                Api.showWarning("Failed to authorize: " + response);
            }

        },
    }
}
</script>

<style lang="scss" scoped>
    .page-content {
        display: flex;
        justify-content: center;
        align-items: center;        
    }
    .centered {
        min-width: 20%;
        max-width: 400px;
    }
    .inf-group {
        margin-bottom: 4px;
    }
    #keep-me-in {
        margin-right: 4px;
    }
    .buttons {
        justify-content: space-between;
        margin-top: 24px;
        a, button {
            min-width: 100px;
        }
    }
    .title {
        font-size: 1.4em;
        font-weight: 600;
        margin-bottom: 1rem;
        text-align: center;
    }
    .externalSystems {
        display: flex;
        justify-content: center;
        margin-top: 16px;
    }
    .oauth-i {
        width: 32px;
        height: 32px;
        margin: 8px;
    }
</style>


<i18n>
{
    en: {
    },
    ru: {
        "Register": "Зарегистрироваться",
        "Login": "Войти",
        "Forget?": "Забыли?",
        "Remember me": "Запомнить",
        "Password": "Пароль",        
    }
}
</i18n>
